import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UpdateMyRoleTypesModel } from '../models/volunteer-role.model';
import { API_ENDPOINT, USER_API_ENDPOINT } from './../config';

@Injectable({
  providedIn: 'root',
})
export class VolunteerRoleService {

  constructor(
    private http: HttpClient,
  ) { }

  getRoles(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/volunteerRole/role-type-list').pipe(map(res => res));
  }

  getSingleRoles(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/volunteerRole/single-role-type-list').pipe(map(res => res));
  }

  getMyRoles(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/volunteerRole/my-role-type-list').pipe(map(res => res));
  }

  updateMyRoles(model: UpdateMyRoleTypesModel): Observable<any> {
    return this.http.put(USER_API_ENDPOINT + '/volunteerRole/update-my-role-type-list', model).pipe(
      map(res => res)
    )
  }
}
